const STORAGE_PREFIX = 'billing:sync_subscription_status:last_attempt:'
const DEFAULT_COOLDOWN_MS = 10 * 60 * 1000

function safeLocalStorageGet(key: string): string | null {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function safeLocalStorageSet(key: string, value: string): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function shouldAttemptSubscriptionSync(
  stripeSubscriptionId: string,
  nowMs: number = Date.now(),
  cooldownMs: number = DEFAULT_COOLDOWN_MS,
): boolean {
  const subId = String(stripeSubscriptionId || '').trim()
  if (!subId) return false

  const raw = safeLocalStorageGet(`${STORAGE_PREFIX}${subId}`)
  if (!raw) return true

  const lastMs = Number(raw)
  if (!Number.isFinite(lastMs)) return true
  return (nowMs - lastMs) >= cooldownMs
}

export function markSubscriptionSyncAttempt(
  stripeSubscriptionId: string,
  nowMs: number = Date.now(),
): void {
  const subId = String(stripeSubscriptionId || '').trim()
  if (!subId) return
  safeLocalStorageSet(`${STORAGE_PREFIX}${subId}`, String(nowMs))
}

